
export class NmeaConfigField {
        
    public name:string
    public libelleFr:string
    public libelleEn:string
    public plotGroup:string
    public unit:string
    public canBePlot:boolean
    public onMainPlot:boolean
    public offsetYoForPlot:number

    constructor({name = '',plotGroup='', libelleFr='', libelleEn='',unit='',canBePlot=false,onMainPlot=false,offsetYoForPlot=0} = {}) {
        this.name = name
        this.libelleFr = libelleFr
        this.libelleEn = libelleEn
        this.unit = unit
        this.canBePlot = canBePlot
        this.onMainPlot = onMainPlot
        this.plotGroup = plotGroup
        this.offsetYoForPlot = offsetYoForPlot
    }    
}
